document.addEventListener('DOMContentLoaded', () => {
    initScrollProgressBar();

    initTableOfContents();

    initBannerInViewFocus();

    initFAQ();

    initNavigatorCompactOnScroll();

});

function initScrollProgressBar() {
    const progressBar = document.getElementById('ebProgress');
    if (!progressBar) return;

    window.addEventListener('scroll', () => {
        const doc = document.documentElement;

        const scrollHeight = doc.scrollHeight;
        const clientHeight = doc.clientHeight;
        const scrollTop = doc.scrollTop;

        const scrollPercent =
            (scrollTop / (scrollHeight - clientHeight)) * 100;

        progressBar.style.width = scrollPercent + '%';
    });
}

function initTableOfContents() {
    const article = document.querySelector('#article-rte');
    const content = document.querySelector('#article-content');
    const toc = document.querySelector('#table-of-contents');

    if (!article || !toc) return;

    const oldNav = toc.querySelector('#navigator');
    if (oldNav) oldNav.remove();

    const ul = document.createElement('ul');
    ul.id = 'navigator';
    ul.className =
        'toc-list text-md leading-6 text-[#999999] flex flex-col gap-4';
    toc.appendChild(ul);

    const headings = Array.from(article.querySelectorAll('h2'));
    if (!headings.length) return;

    const tocItems = [];
    let isClicking = false;
    let lastActiveIndex = 0;

    const SCROLL_LOCK_TIME = 500;

    const detectDirection = (newIndex) => {
        if (newIndex === lastActiveIndex) return;

        toc.classList.remove('active-up', 'active-down');

        toc.classList.add(
            newIndex > lastActiveIndex ? 'active-down' : 'active-up'
        );

        lastActiveIndex = newIndex;
    };

    const scrollToHeading = (h2) => {
        const rect = h2.getBoundingClientRect();
        const container = content;

        const canScrollContainer =
            container.scrollHeight > container.clientHeight;

        if (canScrollContainer) {
            const offset =
                rect.top -
                container.getBoundingClientRect().top +
                container.scrollTop;

            container.scrollTo({ top: offset, behavior: 'smooth' });
        } else {
            let offsetTop = window.scrollY + rect.top - 80;

            if (toc.classList.contains('active-up')) {
                offsetTop = window.scrollY + rect.top - 200;
            }

            window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }
    };

    headings.forEach((h2, index) => {
        if (!h2.id) {
            const id = h2.textContent
                .trim()
                .toLowerCase()
                .replace(/[^\w\s-]/g, '')
                .replace(/\s+/g, '-');

            h2.id = `${id}-${index}`;
        }

        const li = document.createElement('li');
        li.className = 'toc-item pl-4 relative';

        const a = document.createElement('a');
        a.href = `#${h2.id}`;
        a.textContent = h2.textContent;
        a.className = 'block';

        a.addEventListener('click', (e) => {
            e.preventDefault();

            isClicking = true;

            tocItems.forEach((i) => i.classList.remove('active'));
            li.classList.add('active');

            detectDirection(index);
            scrollToHeading(h2);

            setTimeout(() => {
                isClicking = false;
            }, SCROLL_LOCK_TIME);
        });

        li.appendChild(a);
        ul.appendChild(li);
        tocItems.push(li);
    });

    const updateActive = () => {
        if (isClicking) return;

        const isInsideScroll =
            content.scrollHeight > content.clientHeight;

        const centerY = isInsideScroll
            ? content.getBoundingClientRect().top +
            content.clientHeight / 2
            : window.innerHeight / 2;

        let bestIndex = 0;
        let bestDistance = Infinity;

        headings.forEach((h, idx) => {
            const rect = h.getBoundingClientRect();
            const mid = rect.top + rect.height / 2;
            const dist = Math.abs(mid - centerY);

            if (dist < bestDistance) {
                bestDistance = dist;
                bestIndex = idx;
            }
        });

        tocItems.forEach((li, idx) =>
            li.classList.toggle('active', idx === bestIndex)
        );

        if (bestIndex !== lastActiveIndex) {
            detectDirection(bestIndex);
        }
    };

    const container = content;

    const scrollTarget =
        container.scrollHeight > container.clientHeight
            ? container
            : window;

    scrollTarget.addEventListener('scroll', () => {
        requestAnimationFrame(updateActive);
    }, { passive: true });

    updateActive();
}

function initBannerInViewFocus() {
    const banners = document.querySelectorAll('.eb-banner-inview');
    if (!banners.length) return;

    const body = document.body;
    const header = document.querySelector('header');

    const options = {
        root: null,
        threshold: 1,
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const el = entry.target;

            if (entry.isIntersecting) {
                body.classList.add('has-focus');
                header?.classList.add('is-focused');
                el.classList.add('is-focused');
            } else {
                el.classList.remove('is-focused');
                const anyFocused = document.querySelector('.eb-banner-inview.is-focused');

                if (!anyFocused) {
                    body.classList.remove('has-focus');
                    header?.classList.remove('is-focused');
                }
            }
        });
    }, options);

    banners.forEach((banner) => observer.observe(banner));
}

function initFAQ() {
    const accordions = document.querySelectorAll('.accordion-details');
    if (!accordions.length) return;

    const closeAccordion = (details, content) => {
        const base = parseInt(details.dataset.baseHeight);
        const fullHeight = details.scrollHeight;

        details.style.height = fullHeight + 'px';
        details.setAttribute('aria-expanded', 'false');

        requestAnimationFrame(() => {
            details.style.transition = 'height 0.25s ease';
            content.style.transition = 'opacity 0.2s ease';

            details.style.height = base + 'px';
            content.style.opacity = 0;
            content.style.pointerEvents = 'none';
        });

        details.addEventListener(
            'transitionend',
            function handler(e) {
                if (e.propertyName === 'height') {
                    details.removeAttribute('open');
                    details.removeEventListener(
                        'transitionend',
                        handler
                    );
                }
            }
        );
    };

    const openAccordion = (details, content) => {
        const base = parseInt(details.dataset.baseHeight);
        const contentHeight = content.scrollHeight;

        details.setAttribute('open', '');
        details.setAttribute('aria-expanded', 'true');
        details.style.height = base + 'px';

        content.style.opacity = 0;
        content.style.pointerEvents = 'none';

        requestAnimationFrame(() => {
            details.style.transition = 'height 0.25s ease';
            content.style.transition = 'opacity 0.2s ease';

            details.style.height = base + contentHeight + 'px';
            content.style.opacity = 1;
            content.style.pointerEvents = 'auto';
        });

        details.addEventListener(
            'transitionend',
            function handler(e) {
                if (e.propertyName === 'height') {
                    details.style.height = 'auto';
                    details.removeEventListener(
                        'transitionend',
                        handler
                    );
                }
            }
        );
    };

    accordions.forEach((details) => {
        const summary = details.querySelector('summary');
        const content = details.querySelector(
            '.accordion-details__content'
        );

        if (!summary || !content) return;

        const baseHeight =
            summary.offsetHeight +
            parseInt(getComputedStyle(details).paddingTop) +
            parseInt(getComputedStyle(details).paddingBottom);

        details.dataset.baseHeight = baseHeight;

        if (!details.hasAttribute('open')) {
            details.style.height = baseHeight + 'px';
            content.style.opacity = 0;
            content.style.pointerEvents = 'none';
        }

        summary.addEventListener('click', (e) => {
            e.preventDefault();

            if (!details.hasAttribute('open')) {
                accordions.forEach((other) => {
                    if (
                        other !== details &&
                        other.hasAttribute('open')
                    ) {
                        const otherContent =
                            other.querySelector(
                                '.accordion-details__content'
                            );
                        closeAccordion(other, otherContent);
                    }
                });
            }

            if (details.hasAttribute('open')) {
                closeAccordion(details, content);
            } else {
                openAccordion(details, content);
            }
        });
    });
}

function initNavigatorCompactOnScroll() {
    const navigatorEl = document.querySelector('#table-of-contents');
    const bannerEl = document.querySelector('.banner-article-ads');

    if (!navigatorEl || !bannerEl) return;

    let lastScrollY = window.scrollY;

    window.addEventListener('scroll', () => {
        const currentY = window.scrollY;
        const isDesktop = window.innerWidth >= 1024;

        if (isDesktop) {
            if (currentY > lastScrollY) {
                navigatorEl.classList.add('compact');
                bannerEl.classList.add('compact');
            } else {
                navigatorEl.classList.remove('compact');
                bannerEl.classList.remove('compact');
            }
        }

        lastScrollY = currentY <= 0 ? 0 : currentY;
    });
}